import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
  selector: 'app-collapser-item',
  imports: [],
  templateUrl: './collapser-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './collapser-item.component.scss'
})
export class CollapserItemComponent {
    @Input() visible = true;
}
